<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<Dummy></Dummy>
	
	2019-06-08	init

-->

<template>
	<div class="CvInput" :class="elmClasses">
		<BaseText
			:value="value"
			@input="input"
		></BaseText>
		
		<!--
		<div class="CvSelect__debug">
			rule: {{rule}} <br />
			value: {{value}} <br />
		</div>
		-->
	</div>
</template>

<script>
	// @ is an alias to /src
	//import { EventBus } from '@/event-bus.js'
	//import BaseInput from '@/components/MhForm/BaseInput.vue'
	import BaseText from '@/components/MhForm/v1/BaseText.vue'

	export default {
		name: 'CvInput',
		components: {
			//BaseInput,
			BaseText,
		},
		mixins: [],
		props: {
			//rule  : [String, Boolean],
			value : [String, Number, Boolean],
		},
		data() {
			return {}
		},
		watch: {},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				//classes.push('new_class')
				
				return classes
			},
		},
		methods: {
			input( e ) {
				//console.log('event:', event)
				this.$emit('input', e)
			},
		},
		created() {},
		mounted() {},
		destroyed () {},
	}
</script>

<style lang="less">
	@import "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.CvInput {}
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
